module.exports = __webpack_public_path__ + "img/44a-config-legislacoes-show.f3b2b923.png";